import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { dateTimeToView } from "helpers/date";
import { platformNewsItemSections } from "helpers/enums";
import { paths } from "helpers/paths";
import { DateRangeColumnFilter, rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import { enumLabel } from "helpers/system";
import React from "react";
import { Link } from "react-router-dom";

export class AdminPlatformNews extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "header",
                filterable: true,
                Cell: ({ value, row: { original } }) => {
                    const { id } = original;
                    return <Link to={paths.adminPlatformNewsShow(id)}>{value}</Link>;
                },
            },
            {
                Header: "Раздел",
                accessor: "section",
                filterable: true,
                filterType: "enum",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            inputProps: { name: "status" },
                            options: platformNewsItemSections,
                        }}
                    />
                ),
                Cell: ({ value }) => enumLabel(platformNewsItemSections, value),
                CSVExport: ({ value }) => enumLabel(platformNewsItemSections, value),
            },
            { Header: "Кол-во просмотров", accessor: "viewCount" },
            { Header: "Кол-во лайков", accessor: "likeCount" },
            { Header: "Кол-во дислайков", accessor: "dislikeCount" },
            {
                Header: "Дата создания",
                accessor: "createdAt",
                filterable: true,
                filterType: "dateTimeRange",
                Filter: DateRangeColumnFilter,
                Cell: ({ value }) => dateTimeToView(value),
                CSVExport: ({ value }) => dateTimeToView(value),
            },
            {
                Header: "Дата редактирования",
                accessor: "updatedAt",
                filterable: true,
                filterType: "dateTimeRange",
                Filter: DateRangeColumnFilter,
                Cell: ({ value }) => dateTimeToView(value),
                CSVExport: ({ value }) => dateTimeToView(value),
            },
        ];
    }

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
}

export default tableContainer(AdminPlatformNews, "admin-platform-news");
